'use strict';

import Vue from 'vue';
import { logger } from '@/logging';


export const acceptDisclaimer = async (context, userID) => {
	const { User } = Vue.$FeathersVuex;
	
	try {
		const user = new User({ id: userID, disclaimerAcceptedAt: new Date() });
		await user.save();
	}
	catch(err) {
		logger.get('users').error('Error when accepting disclaimer', err);
		throw err;
	}
};
